import Immutable from 'immutable';
import { DocId } from 'records/Doc';
import { RawSpace, Space, SpaceList } from 'records/Space';
import GQLRequest from 'utils/GQLRequest';

export const getSpaces = async (documentid: DocId): Promise<SpaceList> => {
  const { spaces } = await new GQLRequest()
    .query(
      `
      query GetSpaces($documentid: String!) {
        spaces(documentid: $documentid) {
          spaceid
          pageid
          documentid
          pageIndex
          title
          path {
            points
          }
          color {
            space
            components
          }
          opacity
        }
      }
      `
    )
    .variables({ documentid })
    .json<{ spaces: RawSpace[] }>();

  return Immutable.List(spaces.map(Space.deserialize));
};
